import React from 'react';
import { Box } from '@front10/base-elements';
import { useTranslation } from '@front10/utils';

const alertText =
  'No results available for the selected criteria, please select alternate combinations';

export function NoResultsAlert() {
  const translate = useTranslation();
  return (
    <Box role="alert" variant="alerts.default">
      {translate(`cmp-premium-experience-grid-alert`, alertText)}
    </Box>
  );
}
